module.exports = __webpack_public_path__ + "static/media/dokia-redefinePassword.0cfb3887.svg";